import { generateCloudinaryMockupUrl } from "@merchstores/shared/components/Cloudinary";
import { ILogoMockupImageProps } from ".";

export const LogoMockupImage = (props: ILogoMockupImageProps) => {
  const { imgHeight, imgWidth, tags, logoUrl, imgUrl, cloudinarySource, classes } = props;
  return (
    <img
      className={classes ? classes : ""}
      loading="lazy"
      src={generateCloudinaryMockupUrl(imgHeight, imgWidth, tags, logoUrl.toString(), imgUrl, cloudinarySource)}
    />
  );
};
